export const IS_ADMIN = 'IsAdmin'
export const IS_RESOURCE = 'IsResource'
export const IS_MENTOR = 'IsMentor'
export const IS_SALES = 'IsSales'

export const flatpickrConfig = {
  altInput: true,             
  altFormat: 'd-m-Y',  
}
